/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TermsOfAgreementSlidingScalesInner
 */
export interface TermsOfAgreementSlidingScalesInner {
    /**
     * 
     * @type {string}
     * @memberof TermsOfAgreementSlidingScalesInner
     */
    readonly id?: string;
    /**
     * 
     * @type {Date}
     * @memberof TermsOfAgreementSlidingScalesInner
     */
    readonly dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TermsOfAgreementSlidingScalesInner
     */
    readonly dateUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof TermsOfAgreementSlidingScalesInner
     */
    threshold: string;
    /**
     * 
     * @type {string}
     * @memberof TermsOfAgreementSlidingScalesInner
     */
    commissionRate: string;
    /**
     * 
     * @type {string}
     * @memberof TermsOfAgreementSlidingScalesInner
     */
    termsOfAgreement?: string | null;
}

/**
 * Check if a given object implements the TermsOfAgreementSlidingScalesInner interface.
 */
export function instanceOfTermsOfAgreementSlidingScalesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "threshold" in value;
    isInstance = isInstance && "commissionRate" in value;

    return isInstance;
}

export function TermsOfAgreementSlidingScalesInnerFromJSON(json: any): TermsOfAgreementSlidingScalesInner {
    return TermsOfAgreementSlidingScalesInnerFromJSONTyped(json, false);
}

export function TermsOfAgreementSlidingScalesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermsOfAgreementSlidingScalesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'dateCreated': !exists(json, 'date_created') ? undefined : (new Date(json['date_created'])),
        'dateUpdated': !exists(json, 'date_updated') ? undefined : (new Date(json['date_updated'])),
        'threshold': json['threshold'],
        'commissionRate': json['commission_rate'],
        'termsOfAgreement': !exists(json, 'terms_of_agreement') ? undefined : json['terms_of_agreement'],
    };
}

export function TermsOfAgreementSlidingScalesInnerToJSON(value?: TermsOfAgreementSlidingScalesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'threshold': value.threshold,
        'commission_rate': value.commissionRate,
        'terms_of_agreement': value.termsOfAgreement,
    };
}

